import type {
  TGetListaDeImobiliariasCorretoresParams,
  TGetListaDeImobiliariasCorretoresResponse,
} from '@/features/proposta/brasil/types/imobiliarias.types'
import { HttpService } from '@/infra'

export class GetListarImobiliariasCorretoresService extends HttpService {
  async execute(params?: TGetListaDeImobiliariasCorretoresParams) {
    const response = await this.http.get<TGetListaDeImobiliariasCorretoresResponse>(
      '/api/v2/ImobiliariaCorretor/lista',
      { params },
    )
    return response
  }
}
